import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { API_URL } from "../../constant";
import { MdOutlineDone, MdCameraAlt } from "react-icons/md";
import Error from "../../images/shapes/error.png";
import Done from "../../images/shapes/login-tick 1.png";
import "./EditProfile.css";
import { isValidPostalCode } from "../../utils/postalCodeValidator";
import AccountClosureModal from "../../components/AccountClosureModal/AccountClosureModal";

const EditProfile = () => {
  const [showClosureModal, setShowClosureModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteStep, setDeleteStep] = useState(1);
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [profilePhotoPreview, setProfilePhotoPreview] = useState(null);
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    firstName: "",
    surname: "",
    email: "",
    phone: "",
    country_name: "United Kingdom",
    region: "England - City of London",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    city: "",
    postcode: "",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    surname: "",
    email: "",
    phone: "",
  });

  const [touched, setTouched] = useState({
    firstName: false,
    surname: false,
    email: false,
    phone: false,
  });

  const [message, setMessage] = useState({ text: "", type: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isGoogleUser, setIsGoogleUser] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();

  const getApiPrefix = () => {
    const path = window.location.pathname;
    if (path.includes('/retail-business')) return 'retail-business';
    if (path.includes('/retailer-business-agent')) return 'agent';
    if (path.includes('/member')) return 'member';
    return 'customer'; 
  };

  const regionOptions = {
    // ... (keep your existing regionOptions object)
    India: [
      "Andhra Pradesh",
      "Delhi",
      "Karnataka",
      "Maharashtra",
      "Tamil Nadu",
      "West Bengal",
    ],
    "Sri Lanka": [
      "Central Province",
      "Eastern Province",
      "Northern Province",
      "Southern Province",
      "Western Province",
      "North Central Province",
      "North Western Province",
      "Sabaragamuwa Province",
      "Uva Province",
    ],
    Canada: ["Alberta", "British Columbia", "Manitoba", "Ontario", "Quebec"],
    "United Kingdom": [
      "England - Bedfordshire",
      "England - Berkshire",
      "England - Bristol",
      "England - Buckinghamshire",
      "England - Cambridgeshire",
      "England - Cheshire",
      "England - City of London",
      "England - Cornwall",
      "England - Cumbria",
      "England - Derbyshire",
      "England - Devon",
      "England - Dorset",
      "England - Durham",
      "England - East Riding of Yorkshire",
      "England - East Sussex",
      "England - Essex",
      "England - Gloucestershire",
      "England - Greater London",
      "England - Greater Manchester",
      "England - Hampshire",
      "England - Herefordshire",
      "England - Hertfordshire",
      "England - Isle of Wight",
      "England - Kent",
      "England - Lancashire",
      "England - Leicestershire",
      "England - Lincolnshire",
      "England - Merseyside",
      "England - Norfolk",
      "England - North Yorkshire",
      "England - Northamptonshire",
      "England - Northumberland",
      "England - Nottinghamshire",
      "England - Oxfordshire",
      "England - Rutland",
      "England - Shropshire",
      "England - Somerset",
      "England - South Yorkshire",
      "England - Staffordshire",
      "England - Suffolk",
      "England - Surrey",
      "England - Sussex",
      "England - Tyne & Wear",
      "England - Warwickshire",
      "England - West Midlands",
      "England - West Sussex",
      "England - West Yorkshire",
      "England - Wiltshire",
      "England - Worcestershire",

      "Northern Ireland - Antrim",
      "Northern Ireland - Armagh",
      "Northern Ireland - Down",
      "Northern Ireland - Fermanagh",
      "Northern Ireland - Londonderry",
      "Northern Ireland - Tyrone",

      "Scotland - City of Aberdeen",
      "Scotland - Aberdeenshire",
      "Scotland - Angus",
      "Scotland - Argyll",
      "Scotland - Ayrshire",
      "Scotland - Banffshire",
      "Scotland - Berwickshire",
      "Scotland - Bute",
      "Scotland - Caithness",
      "Scotland - Clackmannanshire",
      "Scotland - Dumfriesshire",
      "Scotland - Dunbartonshire",
      "Scotland - City of Dundee",
      "Scotland - East Lothian",
      "Scotland - City of Edinburgh",
      "Scotland - Fife",
      "Scotland - City of Glasgow",
      "Scotland - Inverness-shire",
      "Scotland - Kincardineshire",
      "Scotland - Kinross-shire",
      "Scotland - Kirkcudbrightshire",
      "Scotland - Lanarkshire",
      "Scotland - Midlothian",
      "Scotland - Moray",
      "Scotland - Nairnshire",
      "Scotland - Orkney",
      "Scotland - Peeblesshire",
      "Scotland - Perthshire",
      "Scotland - Renfrewshire",
      "Scotland - Ross and Cromarty",
      "Scotland - Roxburghshire",
      "Scotland - Selkirkshire",
      "Scotland - Shetland",
      "Scotland - Stirlingshire",
      "Scotland - Sutherland",
      "Scotland - West Lothian",
      "Scotland - Wigtownshire",

      "Wales - Blaenau Gwent",
      "Wales - Bridgend",
      "Wales - Caerphilly",
      "Wales - Carmarthenshire",
      "Wales - Ceredigion",
      "Wales - Swansea",
      "Wales - Cardiff",
      "Wales - Conwy",
      "Wales - Denbighshire",
      "Wales - Flintshire",
      "Wales - Gwynedd",
      "Wales - Isle of Anglesey",
      "Wales - Merthyr Tydfil",
      "Wales - Monmouthshire",
      "Wales - Neath Port Talbot",
      "Wales - Newport",
      "Wales - Pembrokeshire",
      "Wales - Powys",
      "Wales - Rhondda Cynon Taf",
      "Wales - Torfaen",
      "Wales - Vale of Glamorgan",
      "Wales - Wrexham",
    ],
    Iran: ["Tehran", "Isfahan", "Fars", "Mazandaran", "Khorasan Razavi"],
  };

  // Fetch user data on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("auth_token");
        if (!token) {
          navigate("/sign_in");
          return;
        }

        const response = await fetch(`${API_URL}/api/${getApiPrefix()}/me`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }

        const data = await response.json();
        const user = data.user;

        // Check if user is a Google user (you might need to adjust this based on your API response)
        setIsGoogleUser(!!user.google_id);

        // Populate form with user data
        setFormData({
          firstName: user.first_name || "",
          surname: user.last_name || "",
          email: user.email || "",
          phone: user.phone || "",
          country_name: user.country || "United Kingdom",
          region: user.region || "England - City of London",
          addressLine1: user.address_line1 || "",
          addressLine2: user.address_line2 || "",
          addressLine3: user.address_line3 || "",
          city: user.city || "",
          postcode: user.postcode || "",
        });

        if (user.photo_url) {
          setProfilePhotoPreview(user.photo_url);
        }

      } catch (error) {
        console.error("Error fetching user data:", error);
        setMessage({
          text: "Failed to load user data. Please try again.",
          type: "error",
        });
      }
    };

    fetchUserData();
  }, [navigate]);

  // Update region when country changes
  useEffect(() => {
    if (formData.country_name && formData.region) {
      const validRegions = regionOptions[formData.country_name] || [];
      const isRegionValid = validRegions.includes(formData.region);

      if (!isRegionValid && validRegions.length > 0) {
        setFormData((prev) => ({
          ...prev,
          region: validRegions[0],
        }));
      }
    }
  }, [formData.country_name]);

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setMessage({ text: "Image size must not exceed 2MB", type: "error" });
        return;
      }
      setProfilePhoto(file);
      setProfilePhotoPreview(URL.createObjectURL(file));
      setMessage({ text: "", type: "" });
    }
  };

  // Validation functions (keep your existing validation functions)
  const validateFirstName = (value) => {
    if (!value.trim()) return "First name is required";
    if (value.length < 3) return "First name must be at least 3 characters";
    return "";
  };

  const validateSurname = (value) => {
    if (!value.trim()) return "Surname is required";
    if (value.length < 3) return "Surname must be at least 3 characters";
    return "";
  };

  const validatePostcode = (value) => {
    if (value && value.trim() && !isValidPostalCode(value, formData.country_name)) return "Please enter a valid postcode";
    return "";
  };

  const validateEmail = (value) => {
    if (!value.trim()) return "Email is required";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) return "Please enter a valid email address";
    return "";
  };

  const validatePhone = (value) => {
    if (!value) return "Phone number is required";
    if (value.replace(/\D/g, "").length < 10)
      return "Please enter a valid phone number";
    return "";
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "email") return;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (touched[name]) {
      let error = "";
      switch (name) {
        case "firstName":
          error = validateFirstName(value);
          break;
        case "surname":
          error = validateSurname(value);
          break;
        default:
          break;
      }

      setErrors((prev) => ({
        ...prev,
        [name]: error,
      }));
    }

    if (message.text) {
      setMessage({ text: "", type: "" });
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === "email") return;

    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));

    let error = "";
    switch (name) {
      case "firstName":
        error = validateFirstName(value);
        break;
      case "surname":
        error = validateSurname(value);
        break;
      case "postcode":
        error = validatePostcode(value);
        break;
      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      phone: value,
    }));

    if (touched.phone) {
      const error = validatePhone(value);
      setErrors((prev) => ({
        ...prev,
        phone: error,
      }));
    }

    if (message.text) {
      setMessage({ text: "", type: "" });
    }
  };

  const handlePhoneBlur = () => {
    setTouched((prev) => ({
      ...prev,
      phone: true,
    }));

    const error = validatePhone(formData.phone);
    setErrors((prev) => ({
      ...prev,
      phone: error,
    }));
  };

  const validateForm = () => {
    const newErrors = {
      firstName: validateFirstName(formData.firstName),
      surname: validateSurname(formData.surname),
      email: "",
      phone: validatePhone(formData.phone),
      postcode: validatePostcode(formData.postcode),
    };

    setErrors(newErrors);
    setTouched({
      firstName: true,
      surname: true,
      email: false,
      phone: true,
      postcode: true,
    });

    const hasErrors = Object.values(newErrors).some((error) => error !== "");
    return !hasErrors;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;

    setIsLoading(true);
    setMessage({ text: "", type: "" });

    try {
      const token = localStorage.getItem("auth_token");
      if (!token) {
        navigate("/sign_in");
        return;
      }

      const formDataToSend = new FormData();
      formDataToSend.append("first_name", formData.firstName);
      formDataToSend.append("last_name", formData.surname);
      formDataToSend.append("phone_number", formData.phone);
      formDataToSend.append("country_name", formData.country_name);
      formDataToSend.append("region", formData.region);
      formDataToSend.append("address_line1", formData.addressLine1);
      formDataToSend.append("address_line2", formData.addressLine2);
      formDataToSend.append("address_line3", formData.addressLine3);
      formDataToSend.append("city", formData.city);
      formDataToSend.append("postcode", formData.postcode);
      const apiPrefix = getApiPrefix();
      if (apiPrefix !== 'agent') {
        formDataToSend.append("_method", "PUT");
      }
      
      if (profilePhoto) {
        formDataToSend.append("photo", profilePhoto);
      }

      const response = await fetch(`${API_URL}/api/${apiPrefix}/update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.errors && data.errors.phone_number) {
          const phoneError = data.errors.phone_number[0];
          if (phoneError.includes("already been taken")) {
            setErrors((prev) => ({
              ...prev,
              phone: "This phone number is already registered. Please use a different number.",
            }));
            setMessage({
              text: "This phone number is already in use. Please try a different number.",
              type: "error",
            });
            return;
          }
        }
        throw new Error(data.message || "Failed to update profile");
      }

      setMessage({
        text: "Profile updated successfully!",
        type: "success",
      });

      setTimeout(() => {
        const path = window.location.pathname;
        if (path.includes('/retail-business')) navigate('/retail-business/wallet');
        else if (path.includes('/retailer-business-agent')) navigate('/retailer-business-agent/wallet');
        else if (path.includes('/members')) navigate('/members/wallet');
        else navigate('/customer/wallet');
      }, 1500);
    } catch (error) {
      setMessage({
        text: error.message || "Failed to update profile. Please try again.",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    setIsDeleting(true);
    try {
      const token = localStorage.getItem("auth_token");
      if (!token) {
        navigate("/sign_in");
        return;
      }

      const reason = selectedReason === "Others" ? otherReason : selectedReason;

      const response = await fetch(`${API_URL}/api/delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          reason: selectedReason,
          other_reason: selectedReason === "Others" ? otherReason : null,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to delete account");
      }

      // Success - proceed to step 4
      setDeleteStep(4);
    } catch (error) {
      setMessage({
        text: error.message || "Failed to delete account. Please try again.",
        type: "error",
      });
      setShowDeleteModal(false);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    const path = window.location.pathname;
    if (path.includes('/retail-business')) navigate('/retail-business/wallet');
    else if (path.includes('/retailer-business-agent')) navigate('/retailer-business-agent/wallet');
    else if (path.includes('/members')) navigate('/members/wallet');
    else navigate('/customer/wallet');
  };

  const handleFinalClose = () => {
    // Clear local storage and redirect to home
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
    setShowDeleteModal(false);
    navigate("/");
  };

  // ... (keep your existing styles)

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "900px",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        className="form-card"
        style={{
          background: "#fff",
          borderRadius: "20px",
          padding: "32px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        }}
      >
          <h2 style={{ textAlign: "center", fontSize: "28px", fontWeight: "900", marginBottom: "4px", background: "linear-gradient(90deg, #2D4CA8 52%, #9F4AFF 60%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Edit Profile</h2>
          <p style={{ textAlign: "center", color: "#063b8a", fontWeight: "700", fontSize: "14px", marginBottom: "24px" }}>
            You can edit your details to update your profile.
            {isGoogleUser && (
              <span style={{ display: "block", color: "#666", fontSize: "12px", marginTop: "5px" }}>
                Note: You signed up with Google, so your email cannot be changed.
              </span>
            )}
          </p>

          {message.text && (
            <div style={{ textAlign: "center", padding: "10px", borderRadius: "8px", margin: "20px 0", fontWeight: "500", backgroundColor: message.type === "error" ? "#ffebee" : "#e8f5e9", color: message.type === "error" ? "#c62828" : "#2e7d32" }}>
              {message.text}
            </div>
          )}

          {/* Profile Photo Section */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "30px" }}>
            <div 
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                backgroundColor: "#f0f0f0",
                position: "relative",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "3px solid #0000A0",
                overflow: "hidden"
              }}
              onClick={() => fileInputRef.current.click()}
            >
              {profilePhotoPreview ? (
                <img src={profilePhotoPreview} alt="Profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              ) : (
                <span style={{ fontSize: "40px", color: "#ccc" }}>+</span>
              )}
              <div style={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                height: "30px",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                fontSize: "12px"
              }}>
                <MdCameraAlt size={16} />
              </div>
            </div>
            <input 
              type="file" 
              ref={fileInputRef}
              onChange={handlePhotoChange}
              accept="image/jpeg, image/png, image/jpg, image/webp"
              style={{ display: "none" }}
            />
            <span style={{ marginTop: "10px", fontSize: "14px", color: "#052C65", fontWeight: "600", cursor: "pointer" }} onClick={() => fileInputRef.current.click()}>Change Photo</span>
          </div>

          {/* Name Box */}
          <div style={{ backgroundColor: "#ffffff", border: "1px solid #dcdcdc", borderRadius: "17.6px", padding: "20px", marginBottom: "16px", boxSizing: "border-box" }} className="mb-2 p-3">
            <div style={{ fontSize: "18px", fontWeight: "700", color: "#052C65", marginBottom: "12px" }} className="mb-1">Name</div>
            <div className="row g-3 ">
              <div className="col-12 col-md-6 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>First name</label>
                <input
                  type="text"
                  name="firstName"
                  placeholder="John"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  style={errors.firstName ? { ...inputStyle, border: "1px solid #d32f2f", width: "100%" } : { ...inputStyle, width: "100%" }}
                  disabled={isLoading}
                 maxLength={255} />
                {errors.firstName && <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>{errors.firstName}</span>}
              </div>
              <div className="col-12 col-md-6 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>Surname</label>
                <input
                  type="text"
                  name="surname"
                  placeholder="Wick"
                  value={formData.surname}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  style={errors.surname ? { ...inputStyle, border: "1px solid #d32f2f", width: "100%" } : { ...inputStyle, width: "100%" }}
                  disabled={isLoading}
                 maxLength={255} />
                {errors.surname && <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>{errors.surname}</span>}
              </div>
            </div>
          </div>

          {/* Contact Box */}
          <div style={{ backgroundColor: "#ffffff", border: "1px solid #dcdcdc", borderRadius: "17.6px", padding: "20px", marginBottom: "16px", boxSizing: "border-box" }} className="mb-2 p-3">
            <div style={{ fontSize: "18px", fontWeight: "700", color: "#052C65", marginBottom: "12px" }} className="mb-1">Contact</div>
            <div className="row g-3">
              <div className="col-12 col-md-6 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="johnwick01@gmail.com"
                  value={formData.email}
                  style={{ ...inputStyle, backgroundColor: "#f5f5f5", color: "#666", cursor: "not-allowed", width: "100%" }}
                  disabled={true}
                  readOnly
                 maxLength={255} />
                <small style={{ color: "#666", fontSize: "12px", marginTop: "4px" }}>Email cannot be changed</small>
              </div>
              <div className="col-12 col-md-6 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>Phone number</label>
                <PhoneInput
                  country={"gb"}
                  value={formData.phone}
                  onChange={handlePhoneChange}
                  onBlur={handlePhoneBlur}
                  inputStyle={errors.phone ? { ...phoneInputStyle, border: "1px solid #d32f2f" } : phoneInputStyle}
                  buttonStyle={{ borderRadius: "12px 0 0 12px" }}
                  disabled={isLoading}
                />
                {errors.phone && <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>{errors.phone}</span>}
              </div>
            </div>
          </div>

          {/* Address Box */}
          <div style={{ backgroundColor: "#ffffff", border: "1px solid #dcdcdc", borderRadius: "17.6px", padding: "20px", marginBottom: "16px", boxSizing: "border-box" }} className="mb-2 p-3">
            <div style={{ fontSize: "18px", fontWeight: "700", color: "#052C65", marginBottom: "12px" }} className="mb-1">Address</div>
            
            <div className="row g-3 mb-3">
              <div className="col-12 col-md-6 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>Address Line 1</label>
                <input
                  type="text"
                  name="addressLine1"
                  placeholder="Address Line 1"
                  value={formData.addressLine1}
                  onChange={handleInputChange}
                  style={{ ...inputStyle, width: "100%" }}
                  disabled={isLoading}
                 maxLength={255} />
              </div>
              <div className="col-12 col-md-6 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>Address Line 2</label>
                <input
                  type="text"
                  name="addressLine2"
                  placeholder="Address Line 2"
                  value={formData.addressLine2}
                  onChange={handleInputChange}
                  style={{ ...inputStyle, width: "100%" }}
                  disabled={isLoading}
                 maxLength={255} />
              </div>
            </div>

            <div className="row g-3 mb-3">
              <div className="col-12 col-md-4 mt-0 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>Address Line 3</label>
                <input
                  type="text"
                  name="addressLine3"
                  placeholder="Address Line 3"
                  value={formData.addressLine3}
                  onChange={handleInputChange}
                  style={{ ...inputStyle, width: "100%" }}
                  disabled={isLoading}
                 maxLength={255} />
              </div>
              <div className="col-12 col-md-4 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>City</label>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={formData.city}
                  onChange={handleInputChange}
                  style={{ ...inputStyle, width: "100%" }}
                  disabled={isLoading}
                 maxLength={255} />
              </div>
              <div className="col-12 col-md-4 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>Postcode</label>
                <input
                  type="text"
                  name="postcode"
                  placeholder="Postcode"
                  value={formData.postcode}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  style={{ ...inputStyle, width: "100%", borderColor: errors.postcode ? "#ff3333" : "#E2E8F0" }}
                  disabled={isLoading}
                 maxLength={20} />
                {errors.postcode && touched.postcode && (
                  <span style={{ color: "#ff3333", fontSize: "12px", marginTop: "4px", display: "block" }}>{errors.postcode}</span>
                )}
              </div>
            </div>

            <div className="row g-3">
              <div className="col-12 col-md-6 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>Country</label>
                <select
                  name="country_name"
                  value={formData.country_name}
                  onChange={handleInputChange}
                  style={{ ...selectStyle, width: "100%" }}
                  disabled={isLoading}
                >
                  <option>United Kingdom</option>
                  <option>India</option>
                  <option>Sri Lanka</option>
                  <option>Canada</option>
                  <option>Iran</option>
                </select>
              </div>
              <div className="col-12 col-md-6 mt-0 pt-2 pb-2">
                <label style={{ fontWeight: "medium", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" }}>Region</label>
                <select
                  name="region"
                  value={formData.region}
                  onChange={handleInputChange}
                  style={{ ...selectStyle, width: "100%" }}
                  disabled={isLoading}
                >
                  {(regionOptions[formData.country_name] || []).map((region) => (
                    <option key={region} value={region}>
                      {region}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column flex-md-row justify-content-md-end gap-3 mt-5 mb-5 button-container">
            <button
              style={{ ...secondaryButtonStyle, opacity: isLoading ? 0.7 : 1, cursor: isLoading ? "not-allowed" : "pointer" }}
              className="cancel-button"
              onMouseOver={(e) => !isLoading && (e.target.style.backgroundColor = "#e0e0e0")}
              onMouseOut={(e) => !isLoading && (e.target.style.backgroundColor = "#ffffff")}
              onClick={handleCancel}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              style={{
                ...deleteButtonStyle,
                opacity: isLoading ? 0.7 : 1,
                cursor: isLoading ? "not-allowed" : "pointer",
                backgroundColor: "#fff",
                color: "#dc2626",
                border: "1px solid #dc2626",
                padding: "10px 18px",
                borderRadius: "8px",
                fontWeight: "600",
              }}
              className="delete-button"
              onClick={() => setShowClosureModal(true)}
              disabled={isLoading}
            >
              Forgot Me – Close My Account
            </button>
            <button
              style={{ ...primaryButtonStyle, opacity: isLoading ? 0.7 : 1, cursor: isLoading ? "not-allowed" : "pointer" }}
              className="primary-button"
              onMouseOver={(e) => !isLoading && (e.target.style.backgroundColor = "#1a1aa0")}
              onMouseOut={(e) => !isLoading && (e.target.style.backgroundColor = "#0000A0")}
              onClick={handleUpdate}
              disabled={isLoading}
            >
              {isLoading ? "Updating..." : "Update"}
            </button>
          </div>

          {showClosureModal && (
            <AccountClosureModal
              isOpen={showClosureModal}
              onClose={() => setShowClosureModal(false)}
            />
          )}

          {/* Delete Modal */}
          {showDeleteModal && (
            <div className="delete-modal-overlay">
              <div className="delete-modal-box">
                <button className="modal-close-btn" onClick={() => setShowDeleteModal(false)}>
                  &times;
                </button>

                {/* STEP 1 */}
                {deleteStep === 1 && (
                  <>
                    <h3>Delete Account</h3>
                    <p>If you'll delete your account, you will lose the following assets.</p>
                    <div className="delete-list">
                      <p><b><MdOutlineDone/></b> You'll lose your customer/member membership.</p>
                      <p><b><MdOutlineDone/></b> You'll lose your earned coins in TopCoin wallet.</p>
                      <p><b><MdOutlineDone/></b> You'll lose your mini/senior advertising agent membership.</p>
                      <p><b><MdOutlineDone/></b> You'll lose your referral earnings.</p>
                      <p><b><MdOutlineDone/></b> You'll lose all your earned money.</p>
                      <p><b><MdOutlineDone/></b> You'll lose all your wallet access.</p>
                    </div>
                    <button className="primary-btn" onClick={() => setDeleteStep(2)}>
                      Continue
                    </button>
                  </>
                )}

                {/* STEP 2 */}
                {deleteStep === 2 && (
                  <>
                    <h3>Delete Account</h3>
                    <p>If you need to delete your account, you must provide a reason.</p>
                    <div className="reason-list">
                      {["No longer needed", "Found a better alternative", "Privacy concerns", "Too many emails/notifications", "Account security concerns", "Others"].map((reason) => (
                        <label key={reason} className="reason-item">
                          <input
                            type="checkbox"
                            checked={selectedReason === reason}
                            onChange={() => setSelectedReason(reason)}
                          />
                          {reason}
                        </label>
                      ))}
                      {selectedReason === "Others" && (
                        <textarea
                          className="reason-textarea"
                          placeholder="Please type your reason"
                          value={otherReason}
                          onChange={(e) => setOtherReason(e.target.value)}
                         maxLength={65535} />
                      )}
                    </div>
                    <button
                      className="primary-btn"
                      onClick={() => setDeleteStep(3)}
                      disabled={!selectedReason || (selectedReason === "Others" && !otherReason)}
                    >
                      Continue
                    </button>
                  </>
                )}

                {/* STEP 3 */}
                {deleteStep === 3 && (
                  <>
                    <h3 style={{color:"red"}}>Delete Account</h3>
                    <img src={Error} alt="warning" className="modal-image" />
                    <p style={{color:"#323232"}}>If you delete your account,</p>
                    <p style={{color:"#323232", marginTop:"-10px"}}>you will lose all accumulated points.</p>
                    <p className="warning-text" style={{color:"red"}}>Are you sure you want to proceed?</p>
                    <div style={{ display: "flex", justifyContent: "center", gap: "15%", marginTop: "60px", marginBottom: "60px" }} className="button-container">
                      <button 
                        className="primary-btn" 
                        onClick={handleDeleteAccount}
                        disabled={isDeleting}
                      >
                        {isDeleting ? "Deleting..." : "Proceed"}
                      </button>
                      <button className="secondary-btn" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                      </button>
                    </div>
                  </>
                )}

                {/* STEP 4 */}
                {deleteStep === 4 && (
                  <>
                    <h3>Your Account Deleted Successfully!</h3>
                    <img src={Done} alt="done" className="modal-image" />
                    <p style={{color:"#323232"}}>We're sorry to see you go</p>
                    <p style={{color:"#323232", marginTop:"-10px"}}>Your account has been successfully deleted.</p>
                    <button className="primary-btn" onClick={handleFinalClose}>
                      Close
                    </button>
                  </>
                )}
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

// Define your styles at the bottom
const inputStyle = {
  width: "100%",
  height: "40px",
  padding: "9px",
  borderRadius: "12px",
  border: "1px solid #ccc",
  fontSize: "14px",
  boxSizing: "border-box",
};

const phoneInputStyle = {
  width: "100%",
  height: "40px",
  padding: "9px",
  borderRadius: "12px",
  border: "1px solid #ccc",
  fontSize: "14px",
  boxSizing: "border-box",
  paddingLeft: "52px",
};

const selectStyle = {
  width: "100%",
  height: "40px",
  padding: "9px",
  borderRadius: "12px",
  border: "1px solid #ccc",
  fontSize: "14px",
  boxSizing: "border-box",
};

const primaryButtonStyle = {
  width: "200px",
  padding: "12px",
  backgroundColor: "#0000A0",
  color: "#fff",
  border: "none",
  borderRadius: "10px",
  fontWeight: "500",
  cursor: "pointer",
  fontSize: "16px",
};

const deleteButtonStyle = {
  width: "200px",
  padding: "12px",
  backgroundColor: "#F94A4C",
  color: "#fff",
  border: "none",
  borderRadius: "10px",
  fontWeight: "500",
  cursor: "pointer",
  fontSize: "16px",
};

const secondaryButtonStyle = {
  width: "200px",
  padding: "12px",
  backgroundColor: "#ffffff",
  color: "#052C65",
  border: "1px solid #052C65",
  borderRadius: "10px",
  fontWeight: "500",
  cursor: "pointer",
  fontSize: "16px",
};

export default EditProfile;